import React from 'react';

const About = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="max-w-2xl p-6 bg-white rounded-lg shadow-md">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">About Cuzpr</h1>
        <p className="text-gray-600 text-lg">
          Welcome to Cuzpr! Our mission is to provide innovative solutions to help businesses grow and succeed. 
          We specialize in technology-driven platforms, ensuring high-quality and scalable products for our clients.
        </p>
        <p className="mt-4 text-gray-600 text-lg">
          At Cuzpr, we are passionate about delivering value and building lasting partnerships. Our team is 
          dedicated to creating tailored solutions that meet the unique needs of every business.
        </p>
      </div>
    </div>
  );
};

export default About;
